import {TweenLite} from "gsap"
import 'gsap/src/uncompressed/plugins/ScrollToPlugin'

class ArrowDown {

    constructor(windowSizes) {
        this.duration = 1.5
        this.windowSizes = windowSizes
        this.arrow = document.querySelector(".section-hero__arrow")
        this.minBubble = this
            .arrow
            .querySelector(".section-hero__arrow__down")
        this.bubble = this
            .arrow
            .querySelector(".section-hero__arrow__down-bubble")
        this.triangle = this
            .arrow
            .querySelector(".arrow__triangle--down")
    }

    init() {
        this.initArrow()

        if (this.windowSizes.mobileDevice) {
            this.initEvents()
        }
    }

    initEvents() {
        this
            .arrow
            .addEventListener('click', this.onDown)
    }

    onDown() {

        TweenLite.to(window, 1, {
            scrollTo: "#section-1",
            ease: Quint.easeInOut
        });
    }

    initArrow() {
        TweenLite.to(this.arrow, this.duration, {
            y: 0 + "px",
            ease: Quint.easeInOut,
            force3D: true
        });
        TweenLite.to(this.minBubble, this.duration, {
            opacity: 1,
            ease: Quint.easeInOut,
            force3D: true
        });
        TweenLite.to(this.bubble, this.duration, {
            opacity: 1,
            delay: .3,
            ease: Quint.easeInOut,
            force3D: true
        });
        TweenLite.to(this.triangle, this.duration, {
            opacity: 1,
            delay: .6,
            ease: Quint.easeInOut,
            force3D: true
        })

    }
    resize(windowSizes) {

        this.windowSizes = windowSizes
    }

}

export default ArrowDown


// WEBPACK FOOTER //
// ./src/js/components/ArrowDown.js